module.exports = __webpack_public_path__ + "img/zuijia_41.ea52536b.png";